import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const TableHeadCol = styled.div<{ $width?: string; $ml?: string; $flex?: string }>`
  color: var(--neutral-500, var(--Input-header, #737373));
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;

  ${({ $width }) => $width && css`
    width: ${$width};
  `}

  ${({ $ml }) => $ml && css`
    margin-left: ${$ml};
  `}

  ${({ $flex }) => $flex && css`
    flex: ${$flex || '1'};
  `}
`;

export const ContainerItem = styled.div`
  width: 100%;
  height: calc(100% - 67px - 59px - 46px);
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  scroll-behavior: smooth;
  background-color: #fff;
  padding-top: 24px;

  @media screen and (max-width: 1025px) {
    margin-bottom: 100px;
  }

  ${({ theme }) => theme.min("sm")`
    ::-webkit-scrollbar {
      width: 11px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #71aaca;
      border-radius: 10px;
      background: #71aaca;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #116595;
      border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #116595;
    }
  `}
`;

// Migrated from PurposeItem/styled.ts
export const Header = styled.div`
  padding: 0 32px;
  display: flex;
  gap: 32px;
  margin-bottom: 16px;

  ${({ theme }) => theme.max("sm")`
    flex-direction: column;
    gap: 24px;
    padding: 0 24px;
  `}
`;

export const HeaderCol = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  ${({ theme }) => theme.max("sm")`
    width: 100%;
  `}
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const Category = styled.span`
  color: #112538;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  word-break: break-word;
`;

export const Area = styled.span`
  padding: 2px 10px;
  border-radius: 16777200px;
  background: #F1F5F9;
  color: #64748B;
  font-family: Inter;
  font-size: 12px;
  line-height: 21px;
  word-break: break-word;
`;

export const Goal = styled.span`
  color: #64748B;
  font-family: Inter;
  font-size: 14px;
  line-height: 22px;
  width: 90%;
  word-break: break-word;
`;

export const HeaderMeasurement = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  width: 50%;

  ${({ theme }) => theme.max("sm")`
    width: 100%;
    justify-content: flex-start;
  `}
`;

export const MeasurementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: 320px;
`;

export const MeasurementTitle = styled.span`
  color: #64748B;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const LockedWrapper = styled.div`
  position: relative;
  height: 100%;
`;
